export default function Description() {
  return (
    <p className="description">
      한글라이즈는{' '}
      <a
        href="https://kornorms.korean.go.kr/regltn/regltnView.do?regltn_code=0003&regltn_no=425"
        target="_blank"
        rel="noreferrer">
        외래어 표기법
      </a>
      을 바탕으로 외국어 단어를 한글로{' '}
      <a
        href="https://ko.wikipedia.org/wiki/%EC%A0%84%EC%82%AC_(%EC%96%B8%EC%96%B4%ED%95%99)"
        target="_blank"
        rel="noreferrer">
        전사
      </a>
      하는 도구입니다. 한글 표기가 알려지지 않은 외국의 인명이나 지명을 한글로 옮겨적는 데에
      활용해보세요.
    </p>
  )
}
